var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500", scrollable: "", persistent: "" },
      model: {
        value: _vm.showSampleDialog,
        callback: function ($$v) {
          _vm.showSampleDialog = $$v
        },
        expression: "showSampleDialog",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { shaped: "", elevation: "5" } },
        [
          _c(
            "v-card-title",
            { staticClass: "bg-primary" },
            [
              _c("v-img", {
                attrs: { src: _vm.colorImageUrl(), "aspect-ratio": "2" },
              }),
              _c("v-spacer"),
              _c("v-text-field", {
                staticStyle: { width: "100px" },
                attrs: {
                  clearable: "",
                  color: "white",
                  "append-icon": "search",
                  filled: "",
                  "hide-details": "",
                  label: _vm._f("capitalize")(_vm.$t("message.forma")),
                },
                model: {
                  value: _vm.sModel,
                  callback: function ($$v) {
                    _vm.sModel = $$v
                  },
                  expression: "sModel",
                },
              }),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", text: "", color: "#fff" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-container",
                { attrs: { "grid-list-md": "", fluid: "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    _vm._l(_vm.filteredModels(), function (model) {
                      return _c(
                        "v-flex",
                        {
                          key: model.ItemCode,
                          class: { active: model == _vm.selectedModel },
                          attrs: { xs6: "" },
                        },
                        [
                          _c(
                            "div",
                            { class: { "invert-image": _vm.darkTheme } },
                            [
                              _c("v-img", {
                                attrs: {
                                  src: _vm.modelLink(model),
                                  "lazy-src": "images/model_placeholder.png",
                                  contain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.selectedModel = model
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "h4",
                            { staticStyle: { "text-align": "center" } },
                            [_vm._v(_vm._s(model.U_THE_MODELLO))]
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", text: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("message.Chiudi")) + " ")]
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    disabled: _vm.selectedModel == null,
                    text: "",
                  },
                  on: {
                    click: function ($event) {
                      _vm.addToCart(_vm.selectedModel)
                      _vm.$emit("close")
                    },
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("message.Aggiungi_al_carrello")) + " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }